import { useSetPosOrderUser } from "@/shared/atoms/usePosOrderUser";
import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import useLayoutData from "@/shared/hooks/useLayoutData";
import { errorToast } from "@/shared/utils/helpers";
import { AppsmenError, ZipcodeApi } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

const useZipcodeApiQuery = (zipcode: any, houseNumber: any) => {
  const { country } = useLayoutData();
  const branch = useBranchId();
  const { setValue } = useFormContext();
  const setOrderUser = useSetPosOrderUser();

  const query = useQuery<ZipcodeApi, AppsmenError>({
    queryKey: ["zipcode", branch, zipcode, houseNumber],
    queryFn: () => {
      return get2(`internal/secure/pos/v1/zipcode/api/${country}/${branch}`, {
        params: {
          zipcode,
          house_number: houseNumber,
        },
      });
    },
    retry: false,
    enabled: false,
  });

  useEffect(() => {
    if (query.isSuccess) {
      const data = query.data as any;
      setOrderUser((prev) => ({
        ...prev,
        city: data.city,
        street_name: data.street,
      }));

      setValue("order_user.street_name", data.street, {
        shouldValidate: true,
      });
      setValue("order_user.city", data.city);
    }
    if (query.isError) {
      const error = query.error as any;
      errorToast(error.response?.data?.error_message);
      setValue("order_user.street_name", "", {
        shouldValidate: true,
      });
      setValue("order_user.city", "");
    }
  }, [query.isSuccess, query.isError]);

  return query;
};

export default useZipcodeApiQuery;
